import { createContext } from 'react'


export const AvailbaleStatsFieldsContext = createContext([])